<script setup>
// Import the image directly
import natureBackground from '/src/assets/nature.svg'
import { useDataStore } from '@/stores/data'
import { useAppStore } from '@/stores/app'

const dataStore = useDataStore()
const appStore = useAppStore()
const splashStyle = {
	background: `url(${natureBackground}) no-repeat center center fixed`,
	backgroundSize: 'cover',
}
</script>

<template>
	<div class="splash" :class="{ active: appStore.initializing, hide: appStore.hidesplash }" :style="splashStyle">
		<div class="middle">
			<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 218 275">
				<defs>
					<linearGradient id="a" x1=".5" y1=".1" x2=".5" y2="1.5" gradientUnits="objectBoundingBox">
						<stop offset="0" stop-color="#e94c2a" />
						<stop offset="1" stop-color="#102068" />
					</linearGradient>
				</defs>
				<path class="pin" d="M207 103c0 48-63 131-91 166a16 16 0 0 1-25 0C63 234 0 151 0 103a103 103 0 0 1 207 0Z" fill="url(#a)" />
				<path class="mark" d="M104 172a17 17 0 0 1-6-2h-1a17 17 0 0 1-5-3 17 17 0 0 1-1-2l-52-63a17 17 0 0 1 2-24 17 17 0 0 1 24 3l38 46L187 9a17 17 0 0 1 24-4 17 17 0 0 1 4 24l-97 135a17 17 0 0 1-1 2 17 17 0 0 1-5 4 17 17 0 0 1-8 1Z" fill="rgba(255,255,255,0.4)" />
			</svg>
			<svg class="rvu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 262.499 132.003">
				<defs>
					<filter id="a" width="113.219" height="132.003" x="149.28" y="0" filterUnits="userSpaceOnUse">
						<feOffset dx="3" />
						<feGaussianBlur result="blur" stdDeviation="5" />
						<feFlood flood-color="#102068" flood-opacity=".553" />
						<feComposite in2="blur" operator="in" />
						<feComposite in="SourceGraphic" />
					</filter>
					<filter id="b" width="120.479" height="129.687" x="65.817" y=".001" filterUnits="userSpaceOnUse">
						<feOffset dx="3" />
						<feGaussianBlur result="blur-2" stdDeviation="5" />
						<feFlood flood-color="#102068" flood-opacity=".553" />
						<feComposite in2="blur-2" operator="in" />
						<feComposite in="SourceGraphic" />
					</filter>
					<filter id="c" width="108.947" height="129.687" x="0" y=".001" filterUnits="userSpaceOnUse">
						<feOffset dx="3" />
						<feGaussianBlur result="blur-3" stdDeviation="5" />
						<feFlood flood-color="#102068" flood-opacity=".553" />
						<feComposite in2="blur-3" operator="in" />
						<feComposite in="SourceGraphic" />
					</filter>
				</defs>
				<g class="u" filter="url(#a)">
					<path
						fill="#fff"
						d="M191.316 115.858a42.164 42.164 0 0 1-10.18-3.512 37.191 37.191 0 0 1-8.242-5.584.745.745 0 0 1-.177-.118 34.041 34.041 0 0 1-6.283-7.625 34.8 34.8 0 0 1-3.876-9.239 41.563 41.563 0 0 1-1.276-10.446V18.308a3.32 3.32 0 0 1 3.335-3.3h16.758a3.32 3.32 0 0 1 3.336 3.3v59.638a20.522 20.522 0 0 0 2.16 9.688 14.81 14.81 0 0 0 6.081 6.121.491.491 0 0 1 .179.159 21.157 21.157 0 0 0 9.861 2.1 20.789 20.789 0 0 0 10.146-2.263 14.745 14.745 0 0 0 6.022-6.121 20.691 20.691 0 0 0 2.138-9.688V18.304a3.3 3.3 0 0 1 3.3-3.3h16.595a3.3 3.3 0 0 1 3.3 3.3V79.33a41.977 41.977 0 0 1-1.262 10.446 35.015 35.015 0 0 1-3.839 9.239 33.987 33.987 0 0 1-6.221 7.625 37.143 37.143 0 0 1-8.321 5.688 41.864 41.864 0 0 1-10.185 3.523 56.63 56.63 0 0 1-11.7 1.152 56.462 56.462 0 0 1-11.649-1.145Z"
					/>
				</g>
				<g class="v" filter="url(#b)"><path fill="#fff" d="M113.356 114.687a3.3 3.3 0 0 1-3.121-2.222L78.001 19.384a3.308 3.308 0 0 1 .431-3 3.3 3.3 0 0 1 2.69-1.387h18.34a3.3 3.3 0 0 1 3.153 2.319l20.444 65.542 20.444-65.542a3.3 3.3 0 0 1 3.153-2.319h18.339a3.3 3.3 0 0 1 2.69 1.387 3.3 3.3 0 0 1 .43 3l-32.232 93.081a3.3 3.3 0 0 1-3.121 2.222Z" data-name="V" /></g>
				<g class="r" filter="url(#c)"><path fill="#fff" d="M68.663 114.687a3.3 3.3 0 0 1-2.929-1.776L48.383 79.632H35.2v31.752a3.3 3.3 0 0 1-3.3 3.3H15.3a3.3 3.3 0 0 1-3.3-3.3V18.3a3.3 3.3 0 0 1 3.3-3.3h37.565a41.754 41.754 0 0 1 18.631 3.885 28.99 28.99 0 0 1 12.362 11.29 32.983 32.983 0 0 1 4.291 17.046 32.87 32.87 0 0 1-5.15 18.257 28.08 28.08 0 0 1-11.054 9.93l18.6 34.406a3.308 3.308 0 0 1-.068 3.262 3.307 3.307 0 0 1-2.838 1.612ZM35.202 60.254h15.96c4.43 0 7.7-1.067 10.005-3.262 2.257-2.151 3.355-5.185 3.355-9.276s-1.142-7.094-3.492-9.3c-2.411-2.265-5.754-3.364-10.221-3.364H35.2Z" data-name="R" /></g>
			</svg>

			<div class="text">Reisevaneundersøkelsen</div>
		</div>
	</div>
</template>

<style>
.splash {
	position: fixed;
	top: 0px;
	left: 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100vh;
	width: 100vw;
	pointer-events: none;
	text-align: center;
	z-index: 99999;
	background-size: cover;
	opacity: 0;
	transition: all 0.3s ease-out;
}

.splash.active {
	opacity: 1;
}

.splash.hide {
	animation: fadeout 1s 0.25s forwards;
}

.splash .middle {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: visible;
}

.splash.hide .middle {
	animation: fallDown 1s forwards;
}

.splash .rvu {
	width: 54vw;
	margin-top: 3vh;
}
.splash .checkmark {
	margin-top: -10vh;
	width: 40vw;
	filter: drop-shadow(20px 20px 20px rgba(0, 0, 0, 0.4));
	overflow: visible;
}
.splash .text {
	color: white;
	font-size: 4.3vw;
	font-weight: 400;
	margin-top: 0vh;
}

.splash .checkmark .pin {
	transform-origin: 50% 50%;
	overflow: visible;
}

.splash.active .checkmark .pin {
	opacity: 0;
	transform: scale3d(0, 0, 0);
	animation: scaleNormal 0.5s forwards;
}

.splash .checkmark .mark {
	transform-origin: 50% 50%;
	overflow: visible;
}

.splash.active .checkmark .mark {
	opacity: 0;
	transform: scale3d(2, 2, 2);
	animation: scaleNormal 0.5s 0.5s forwards;
}

.splash .checkmark {
	overflow: visible;
}

.splash .rvu {
	overflow: visible;
}

.splash.active .rvu {
	opacity: 0;
	transform: translateY(50vh);
	animation: slideUp 0.5s forwards;
}

.splash.active .text {
	opacity: 0;
	transform: translateY(50vh);
	animation: slideUp 0.5s 0.5s forwards;
}

.splash.active .r {
	opacity: 0;
	transform: translateX(20vw);
	animation: slideX 1.25s 0s forwards;
}

.splash.active .v {
	opacity: 0;
	animation: fadein 1.25s 0s forwards;
}

.splash.active .u {
	opacity: 0;
	transform: translateX(-20vw);
	animation: slideX 1.25s 0s forwards;
}

@keyframes slideX {
	to {
		opacity: 1;
		transform: translateX(0vw);
	}
}

@keyframes slideUp {
	to {
		opacity: 1;
		transform: translateY(0vh);
	}
}

@keyframes scaleNormal {
	to {
		opacity: 1;
		transform: scale3d(1, 1, 1);
	}
}

@keyframes fadein {
	to {
		opacity: 1;
	}
}

@keyframes fadeout {
	100% {
		opacity: 0;
	}
}

@keyframes fallDown {
	to {
		opacity: 0;
		transform: translateY(100vh);
	}
}
</style>
